module.exports = __webpack_public_path__ + "media/images/home/watch@2x-c042b8fa79ceaa14eb3eaafb3c7bc2ea.png";